export default __webpack_public_path__ + "static/IBMPlexSans-Text-e3ce8a5719ddbfc775863c15fc413ec5.woff2";